/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const n={stableRendering:!1},e={rootOrigin:null};export{e as gridLocalOriginFactory,n as textTextureAtlas};
